import type { Icon as PhosphorIcon } from '@phosphor-icons/react';
import { Layout } from '@phosphor-icons/react/dist/icons/Layout';
import { Info } from '@phosphor-icons/react/dist/icons/Info';
import { Waves } from '@phosphor-icons/react/dist/icons/Waves';
import { ChatCircle } from '@phosphor-icons/react/dist/icons/ChatCircle';
import { Notepad } from '@phosphor-icons/react/dist/icons/Notepad';
import { GearSix } from '@phosphor-icons/react/dist/icons/GearSix';
import { SidebarSimple } from '@phosphor-icons/react/dist/icons/SidebarSimple';
import { Headset } from '@phosphor-icons/react/dist/icons/Headset';
import { Question } from '@phosphor-icons/react/dist/icons/Question';
import { Keyboard } from '@phosphor-icons/react/dist/icons/Keyboard';
import { Users } from '@phosphor-icons/react/dist/icons/Users';
import { TrendUp } from '@phosphor-icons/react/dist/icons/TrendUp';
import { SquaresFour } from '@phosphor-icons/react/dist/icons/SquaresFour';
import { Book } from '@phosphor-icons/react/dist/icons/Book';
import { ListChecks } from '@phosphor-icons/react/dist/icons/ListChecks';
import { Broadcast } from '@phosphor-icons/react/dist/icons/Broadcast';
import { ClockCounterClockwise } from '@phosphor-icons/react/dist/icons/ClockCounterClockwise';
import { Buildings } from '@phosphor-icons/react/dist/icons/Buildings';
import { FunnelSimple } from '@phosphor-icons/react/dist/icons/FunnelSimple';
import { Table } from '@phosphor-icons/react/dist/icons/Table';
import { TreeStructure } from '@phosphor-icons/react/dist/icons/TreeStructure';
import { ArrowsOut } from '@phosphor-icons/react/dist/icons/ArrowsOut';
import { ArrowsIn } from '@phosphor-icons/react/dist/icons/ArrowsIn';
import { Graph } from '@phosphor-icons/react/dist/icons/Graph';
import { Plus } from '@phosphor-icons/react/dist/icons/Plus';
import { X } from '@phosphor-icons/react/dist/icons/X';
import { CaretRight } from '@phosphor-icons/react/dist/icons/CaretRight';
import { CaretDown } from '@phosphor-icons/react/dist/icons/CaretDown';
import { CaretUp } from '@phosphor-icons/react/dist/icons/CaretUp';
import { CaretLeft } from '@phosphor-icons/react/dist/icons/CaretLeft';
import { DotsSixVertical } from '@phosphor-icons/react/dist/icons/DotsSixVertical';
import { DotsSix } from '@phosphor-icons/react/dist/icons/DotsSix';
import { DotsThree } from '@phosphor-icons/react/dist/icons/DotsThree';
import { MagnifyingGlass } from '@phosphor-icons/react/dist/icons/MagnifyingGlass';
import { Check } from '@phosphor-icons/react/dist/icons/Check';
import { CheckSquare } from '@phosphor-icons/react/dist/icons/CheckSquare';
import { ArrowCounterClockwise } from '@phosphor-icons/react/dist/icons/ArrowCounterClockwise';
import { ArrowSquareOut } from '@phosphor-icons/react/dist/icons/ArrowSquareOut';
import { ArrowRight } from '@phosphor-icons/react/dist/icons/ArrowRight';
import { Play } from '@phosphor-icons/react/dist/icons/Play';
import { Link } from '@phosphor-icons/react/dist/icons/Link';
import { LinkSimple } from '@phosphor-icons/react/dist/icons/LinkSimple';
import { Terminal } from '@phosphor-icons/react/dist/icons/Terminal';
import { Fire } from '@phosphor-icons/react/dist/icons/Fire';
import { EnvelopeSimple } from '@phosphor-icons/react/dist/icons/EnvelopeSimple';
import { Envelope } from '@phosphor-icons/react/dist/icons/Envelope';
import { Phone } from '@phosphor-icons/react/dist/icons/Phone';
import { LinkedinLogo } from '@phosphor-icons/react/dist/icons/LinkedinLogo';
import { PaperPlaneTilt } from '@phosphor-icons/react/dist/icons/PaperPlaneTilt';
import { Stop } from '@phosphor-icons/react/dist/icons/Stop';
import { ArrowUp } from '@phosphor-icons/react/dist/icons/ArrowUp';
import { CalendarCheck } from '@phosphor-icons/react/dist/icons/CalendarCheck';
import { CalendarBlank } from '@phosphor-icons/react/dist/icons/CalendarBlank';
import { Archive } from '@phosphor-icons/react/dist/icons/Archive';
import { Lightning } from '@phosphor-icons/react/dist/icons/Lightning';
import { ClipboardText } from '@phosphor-icons/react/dist/icons/ClipboardText';
import { MapPin } from '@phosphor-icons/react/dist/icons/MapPin';
import { Tag } from '@phosphor-icons/react/dist/icons/Tag';
import { Hash } from '@phosphor-icons/react/dist/icons/Hash';
import { ArrowsClockwise } from '@phosphor-icons/react/dist/icons/ArrowsClockwise';
import { User } from '@phosphor-icons/react/dist/icons/User';
import { UserCircle } from '@phosphor-icons/react/dist/icons/UserCircle';
import { UsersThree } from '@phosphor-icons/react/dist/icons/UsersThree';
import { UserSwitch } from '@phosphor-icons/react/dist/icons/UserSwitch';
import { Globe } from '@phosphor-icons/react/dist/icons/Globe';
import { CurrencyCircleDollar } from '@phosphor-icons/react/dist/icons/CurrencyCircleDollar';
import { Coins } from '@phosphor-icons/react/dist/icons/Coins';
import { ListNumbers } from '@phosphor-icons/react/dist/icons/ListNumbers';
import { PlugsConnected } from '@phosphor-icons/react/dist/icons/PlugsConnected';
import { ArrowsLeftRight } from '@phosphor-icons/react/dist/icons/ArrowsLeftRight';
import { Shield } from '@phosphor-icons/react/dist/icons/Shield';
import { SignOut } from '@phosphor-icons/react/dist/icons/SignOut';
import { CircleNotch } from '@phosphor-icons/react/dist/icons/CircleNotch';
import { Stack } from '@phosphor-icons/react/dist/icons/Stack';
import { UserPlus } from '@phosphor-icons/react/dist/icons/UserPlus';
import { House } from '@phosphor-icons/react/dist/icons/House';
import { FloppyDisk } from '@phosphor-icons/react/dist/icons/FloppyDisk';
import { PencilSimple } from '@phosphor-icons/react/dist/icons/PencilSimple';
import { Recycle } from '@phosphor-icons/react/dist/icons/Recycle';
import { PhoneSlash } from '@phosphor-icons/react/dist/icons/PhoneSlash';
import { Trash } from '@phosphor-icons/react/dist/icons/Trash';
import { PushPin } from '@phosphor-icons/react/dist/icons/PushPin';
import { EyeSlash } from '@phosphor-icons/react/dist/icons/EyeSlash';
import { Lock } from '@phosphor-icons/react/dist/icons/Lock';
import { ArrowsDownUp } from '@phosphor-icons/react/dist/icons/ArrowsDownUp';
import { ArrowsOutLineVertical } from '@phosphor-icons/react/dist/icons/ArrowsOutLineVertical';
import { ArrowsInLineVertical } from '@phosphor-icons/react/dist/icons/ArrowsInLineVertical';
import { IdentificationCard } from '@phosphor-icons/react/dist/icons/IdentificationCard';
import { ThumbsUp } from '@phosphor-icons/react/dist/icons/ThumbsUp';
import { ThumbsDown } from '@phosphor-icons/react/dist/icons/ThumbsDown';
import { Flag } from '@phosphor-icons/react/dist/icons/Flag';
import { Diamond } from '@phosphor-icons/react/dist/icons/Diamond';
import { Copy } from '@phosphor-icons/react/dist/icons/Copy';
import { Briefcase } from '@phosphor-icons/react/dist/icons/Briefcase';
import { Sparkle } from '@phosphor-icons/react/dist/icons/Sparkle';
import { Moon } from '@phosphor-icons/react/dist/icons/Moon';
import { Cloud } from '@phosphor-icons/react/dist/icons/Cloud';
import { PhoneCall } from '@phosphor-icons/react/dist/icons/PhoneCall';
import { List } from '@phosphor-icons/react/dist/icons/List';
import { Toolbox } from '@phosphor-icons/react/dist/icons/Toolbox';
import { Kanban } from '@phosphor-icons/react/dist/icons/Kanban';
import { ListDashes } from '@phosphor-icons/react/dist/icons/ListDashes';

/**
 * One concept → one Phosphor glyph, picked from hb-terra-flow (plan
 * 2026-09-27-005 §3). Never re-pick per screen — add a key here (with the
 * hb `file:line` in a trailing comment) if a new concept needs a glyph.
 *
 * Home: `components/flow/` (not `shell-next/`) on purpose — Phase 2's
 * converted tab bodies (`flow/**`) and the `signal-type-display.ts`/
 * `AccountTimeline` lookups will import this too, and an old screen
 * importing from the new shell's own directory would be an inverted
 * dependency; `flow/` is the shared level both sides can reach.
 *
 * Glaze-free and lucide-free on purpose: only
 * `@phosphor-icons/react/dist/icons/*` deep imports (plus the bare `Icon`
 * TYPE, never the Glaze `Icon` component) — so this file stays importable
 * from Bun-tested mini-app paths later via `_shared/components/flow`
 * (`PlaySectionCard.tsx` already proves Phosphor loads under Bun). The Glaze
 * `Icon` wrapper is applied at the call site, not here.
 *
 * `workspace` is deliberately NOT a key: hb's inert "Workspace" rail item and
 * Terra's own `opportunity` tile both happen to use `Briefcase`, but they are
 * different concepts — see `opportunity` below and this plan's landmines.
 * Never add a `workspace` key unless Terra grows that feature for real.
 */
export const FLOW_ICONS = {
  // shell, rail, header — hb shell/NavRail.tsx, shell/Header.tsx (Phase 1 scope, shipped now)
  flow: Waves, // NavRail.tsx:177
  chat: ChatCircle, // NavRail.tsx:209
  notes: Notepad, // shell-next/notes/ (rail Notes tab, row affordances) — a lined page; `chat` above is a bare bubble, so the two stay distinct
  settings: GearSix, // shell-next/RailAccountMenu.tsx (avatar-menu Preferences item) and shell-next/entity/PromptGear.tsx, no rail gear, trellus/TableSettingsMenu.tsx (table gear)
  dockToggle: SidebarSimple, // shell-next/table/LedgerToolbar.tsx (saved-views pane toggle)
  help: Question, // NavRail.tsx:215 — not a Terra feature, not rendered
  keyboardShortcuts: Keyboard, // NavRail.tsx:242 — not a Terra feature
  people: Users, // NavRail.tsx:84, BottomTabs.tsx:29
  pipeline: TrendUp, // NavRail.tsx:85 — hidden under V2 today (DESIGN_V2_HIDDEN_NAV_KEYS)
  apps: SquaresFour, // shell-next/NavRail.tsx (Apps link)
  playbook: Book, // NavRail.tsx:87
  plays: Book, // BottomTabs.tsx:30 — same concept as playbook, phone tab
  tasks: ListChecks, // NavRail.tsx:88, ContextActions.tsx:333,427,436,619
  broadcasts: Broadcast, // NavRail.tsx:89
  signals: Broadcast, // BottomTabs.tsx:31 — same concept as broadcasts, phone tab
  history: ClockCounterClockwise, // NavRail.tsx:90, rail/plays/PlaysIndex.tsx:133
  companies: Buildings, // BottomTabs.tsx:28, companies/columns.tsx:88, facts.tsx:109

  // table chrome, toolbars, panes — hb table/TableToolbar.tsx, shell/FlowToolbar.tsx, … (Phase 2 consumers)
  filter: FunnelSimple, // TableToolbar.tsx:52, SignalsLedger.tsx:462
  columns: Table, // TableToolbar.tsx:80, SignalsLedger.tsx:517
  groupBy: TreeStructure, // TableToolbar.tsx:96
  add: Plus, // FilterBuilder.tsx:85,89,162; FlowToolbar.tsx:268; GroupByBuilder.tsx:86; ColumnsManager.tsx:115
  close: X, // RailPanel.tsx:47,60; SheetHost.tsx:547; FilterBuilder.tsx:93,144,246
  remove: X, // FilterBuilder.tsx — "remove a filter", same glyph as close
  clear: X, // FlowToolbar.tsx:230
  expand: CaretRight, // GroupedTable.tsx:611, CardList.tsx:364, LensFrame.tsx:165
  expanded: CaretDown, // FlowToolbar.tsx:252,300; LensFrame.tsx:195
  dropdown: CaretDown, // SavedViewsPane.tsx:89, columns.tsx:119 — same glyph as expanded
  collapse: CaretUp, // LeadElement.tsx:106, PlaysIndex.tsx:138
  back: CaretLeft, // RailPanel.tsx:44
  dragHandle: DotsSixVertical, // ColumnsManager.tsx:93
  resizeHandle: DotsSix, // LensFrame.tsx:244
  more: DotsThree, // PersonBand.tsx:405,440; CompanyAnchorLens.tsx:221,228,293,334
  search: MagnifyingGlass, // SavedViewsPane.tsx:93
  confirm: Check, // ui/ConfirmedButton.tsx:59,71; ContextActions.tsx:376
  done: Check, // same glyph as confirm
  completeTask: CheckSquare, // ContextActions.tsx:592
  separateBuyingCenter: CheckSquare, // account/hierarchy/SeparateBuyingCenterIndicator.tsx (checked-checkbox glyph, rendered weight="fill")
  undo: ArrowCounterClockwise, // ContextActions.tsx:409,445
  reopen: ArrowCounterClockwise, // same glyph as undo
  openExternal: ArrowSquareOut, // ContextActions.tsx:294,306
  goTo: ArrowRight, // ContextActions.tsx:319
  addToPlay: Play, // ContextActions.tsx:343
  copyLink: Link, // ContextActions.tsx:653, PersonLens.tsx:350
  link: Link, // same glyph as copyLink
  source: LinkSimple, // SignalLens.tsx:199
  cli: Terminal, // LensFrame.tsx:185 — not a Terra feature yet (hb also uses TerminalWindow/Code elsewhere)
  hot: Fire, // KeyboardSheet.tsx:173

  // record facts and action verbs — hb lens/*, destinations/*, rail/* (Phase 2 consumers)
  email: EnvelopeSimple, // PersonBand.tsx:362, PersonLens.tsx:205, SignalLens.tsx:275, ActionsIndex.tsx:22
  sendEmail: Envelope, // ContextActions.tsx:460,662
  phone: Phone, // columns.tsx VERB_ICON.Call; PersonBand.tsx:363; ActionsIndex.tsx:23
  linkedin: LinkedinLogo, // ContextActions.tsx:490, facts.tsx:114, PlayLens.tsx:5
  send: PaperPlaneTilt, // columns.tsx VERB_ICON.Send/Queue; PersonBand.tsx:372; PlaysIndex.tsx:119
  arrowUp: ArrowUp, // shell-next/chat/ComposerActionButton.tsx — bead terra-design-v2-chat-yub.6, ported from clayground-sc-terra-flow-panels/projects/sc-terra-flow/src/chat/ComposerActionButton.tsx:1 (send action while not streaming)
  stop: Stop, // shell-next/chat/ComposerActionButton.tsx — bead terra-design-v2-chat-yub.6, same prototype file:2 (stop action while streaming); no `stop` key existed before this bead
  book: CalendarCheck, // columns.tsx VERB_ICON.Book; CompanyNextStepLens.tsx:59; SignalLens.tsx:198
  archive: Archive, // signals/SignalResponseRowActions.tsx (icon-only Archive, Signal Response layout)
  date: CalendarBlank, // facts.tsx:112, PersonBand.tsx:371, SignalLens.tsx:204, PlayLens.tsx:212
  signal: Lightning, // PersonBand.tsx:370,412; ContextActions.tsx:558; CompanyAnchorLens.tsx:56; SignalLens.tsx:200
  engagement: Lightning, // same glyph as signal
  intent: Lightning, // same glyph as signal
  note: ClipboardText, // CompanyNextStepLens.tsx:61
  task: ClipboardText, // same glyph as note
  location: MapPin, // facts.tsx:110, PersonBand.tsx:368, SignalLens.tsx:280
  tag: Tag, // PersonBand.tsx:365,421; SignalLens.tsx:197,278,302
  score: Hash, // PersonBand.tsx:369,410; SignalLens.tsx:203
  stage: ArrowsClockwise, // PersonBand.tsx:366
  refresh: ArrowsClockwise, // ActionsIndex.tsx:25 — same glyph as stage
  person: User, // PersonBand.tsx:364; ContextActions.tsx:455,509
  owner: UserCircle, // PersonBand.tsx:367,374; SignalLens.tsx:205; PlayLens.tsx:210
  jobLevel: UserCircle, // same glyph as owner
  team: UsersThree, // PersonBand.tsx:373,422; ActionsIndex.tsx:24; PlayLens.tsx:209
  jobChange: UserSwitch, // ActionsIndex.tsx:26
  website: Globe, // facts.tsx:108; ContextActions.tsx:526,672; SignalLens.tsx:301
  money: CurrencyCircleDollar, // PersonLens.tsx:355-356
  revenue: Coins, // facts.tsx:113
  steps: ListNumbers, // PlayLens.tsx:206
  connectors: PlugsConnected, // PlayLens.tsx:207

  // Terra-only concepts — no hb glyph; Phase 1's own picks (§3's last table)
  switchUser: ArrowsLeftRight, // not in hb; shell-next/RailAccountMenu.tsx (Switch user…)
  admin: Shield, // not in hb; shell-next/RailAccountMenu.tsx (Admin)
  logOut: SignOut, // not in hb; shell-next/RailAccountMenu.tsx (Log out)
  loading: CircleNotch, // not in hb; replaces lucide Loader2 (+ animate-spin)
  queue: Stack, // not in hb; replaces lucide Layers
  customInvite: UserPlus, // not in hb; replaces lucide UserPlus
  addPerson: UserPlus, // same glyph as customInvite
  home: House, // not in hb; replaces lucide Home
  save: FloppyDisk, // not in hb; replaces lucide Save
  recycle: Recycle, // trellus/PhoneRefreshButton.tsx (the one phone control on rows, band and card) — find or re-enrich a contact's phone number
  phoneNotFound: PhoneSlash, // trellus/PhoneRefreshButton.tsx — crossed-out phone: the finished search found no number
  edit: PencilSimple, // not in hb; replaces lucide Pencil
  delete: Trash, // not in hb; replaces lucide Trash2
  pin: PushPin, // not in hb; replaces lucide Pin
  hide: EyeSlash, // not in hb; replaces lucide EyeOff
  locked: Lock, // not in hb; replaces lucide Lock
  sort: ArrowsDownUp, // not in hb; replaces lucide ArrowUpDown
  expandAll: ArrowsOutLineVertical, // not in hb; replaces lucide ChevronsUpDown
  collapseAll: ArrowsInLineVertical, // not in hb; replaces lucide ChevronsDownUp
  campaignMember: IdentificationCard, // not in hb; replaces lucide IdCard
  flag: Flag, // not in hb; replaces lucide Flag
  enrichment: Diamond, // not in hb; replaces lucide Diamond
  copy: Copy, // not in hb; replaces lucide Copy
  opportunity: Briefcase, // Terra's own concept (AccountTimeline.tsx:162) — NOT hb's "Workspace"
  designBeta: Sparkle, // not in hb; avatar-menu "Terra Beta" toggle (shell-next/RailAccountMenu.tsx)
  themeDark: Moon, // not in hb; avatar-menu theme toggle (shell-next/RailAccountMenu.tsx)
  moveUp: CaretUp, // not in hb; shell-next/table/GroupByBuilder.tsx (Move level up) — same glyph as collapse
  moveDown: CaretDown, // not in hb; shell-next/table/GroupByBuilder.tsx (Move level down) — same glyph as expanded/dropdown
  actions: Lightning, // not in hb; shell-next/Header.tsx Actions-panel toggle — same glyph as signal
  thumbsUp: ThumbsUp, // not in hb; shell-next/home/HomeBoardCard.tsx (loop marked useful)
  thumbsDown: ThumbsDown, // not in hb; shell-next/home/HomeBoardCard.tsx (loop marked not useful)

  // integration glyphs — U2b's KindTile (shell-next/ui/KindTile.tsx)
  salesforce: Cloud, // not in hb; PROTO's own stand-in for the SFDC glyph — Phosphor has no literal Salesforce logo
  gong: PhoneCall, // not in hb; Gong call-recording integration

  hierarchy: TreeStructure, // account/hierarchy/* — the account drilldown Hierarchy tab's menu glyphs; not in hb
  tableView: Table, // account/hierarchy/AccountHierarchyTab.tsx Table/Graph toggle
  graphView: Graph, // same toggle
  fullscreen: ArrowsOut, // account/hierarchy/AccountHierarchyTab.tsx "Expand" (full-screen view)
  fullscreenExit: ArrowsIn, // same view's "Close"
  renewing: CalendarCheck, // account/hierarchy/HierarchyLensBar.tsx "Renewing in 90 days" chip

  library: List, // not in hb; shell-next/chat/ChatComposerV2.tsx "Open toolkit" trigger (bead terra-design-v2-chat-yub.15) — V1's glyph at this affordance is the literal "☰" character, `components/skills/Composer.tsx`'s own "Open library" button (`:495`-ish, cited in that bead's description)

  // primary rail — shell-next/rail/rail-items.ts (bead terra-v2-ia-promotion-v2-shell-primary-ia-x37.1). Append-only block.
  accounts: Buildings, // rail Accounts item — same glyph as companies
  categories: Kanban, // rail Categories item
  openLoops: ListDashes, // rail Open Loops item
  myActions: ClockCounterClockwise, // rail My Actions item — same glyph as history (old rail's History icon)
  myTeam: UsersThree, // rail My Team item — same glyph as team
  dialer: Headset, // shell-next/HeadsetButton.tsx — opens/closes the Trellus dialer sidebar; not in hb
  layout: Layout, // flow-layouts/FlowLayoutMenu.tsx — the Layout menu's icon-only (narrow) trigger
  toolkit: Toolbox, // rail Toolkit item (route /library); NOT `library`, which is the chat "Open toolkit" glyph
  info: Info, // shell-next/account/gs/GsUseCaseCard.tsx — the "Assessed <date>" and "What In Use means" popover triggers
} as const satisfies Record<string, PhosphorIcon>;

export type FlowIconName = keyof typeof FLOW_ICONS;
